// react
import { ReactNode } from 'react';

// material ui
import { Box, CardHeader } from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// feature-components
import AlarmStateSelect from '@/features/alarm-hub/components/AlarmStateSelect.tsx';
// eslint-disable-next-line import/no-restricted-paths
import EnergyXplorerAlarmStateActions from '@/features/energyxplorer/components/alarms/EnergyXplorerAlarmStateActions';

// feature-utils
import formatDate from '@/features/alarm-hub/utils/formatDate';

// relative
import AlarmMetaDataDrawer from './electricitySystem/AlarmMetaDataDrawer';

type AlarmTypeCardHeaderProps = {
  alarm: ReadAlarmDto;
  title: ReactNode;
  showSubheader?: boolean;
  showMetaDataDrawer?: boolean;
  showStateSelect?: boolean;
  actionsEnd?: ReactNode;
};

const AlarmTypeCardHeader = ({
  alarm,
  title,
  showSubheader = true,
  showMetaDataDrawer = true,
  showStateSelect = true,
  actionsEnd = null,
}: AlarmTypeCardHeaderProps) => {
  const formattedDate = formatDate(alarm.Created);

  const subheader = showSubheader ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {formattedDate}
    </Box>
  ) : undefined;

  const hasAction =
    showMetaDataDrawer || showStateSelect || Boolean(actionsEnd);
  const action = hasAction ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {showMetaDataDrawer ? (
        <AlarmMetaDataDrawer
          alarmType={alarm.AlarmType}
          alarmSubtype={alarm.AlarmSubtype}
          metaData={alarm.MetaData}
        />
      ) : null}
      {showStateSelect ? (
        alarm.State === 'Unresolved' ? (
          <EnergyXplorerAlarmStateActions
            accountId={String(alarm.AccountId)}
            alarm={{ alarmId: alarm.AlarmId, state: alarm.State }}
          />
        ) : (
          <AlarmStateSelect alarm={alarm} />
        )
      ) : null}
      {actionsEnd}
    </Box>
  ) : undefined;

  return (
    <CardHeader
      title={title}
      subheader={subheader}
      action={action}
      slotProps={{
        title: { variant: 'h6', fontWeight: 600 },
      }}
    />
  );
};

export default AlarmTypeCardHeader;
